<template>
  <div class='h-100 uk-flex'>
    <div class='h-100'>
      <ItemList :list='groupList' :mapper='groupMapper' @add='onGroupAdd' @select='onGroupSelect'
                @edit='onGroupEdit' @delete='onGroupDelete'></ItemList>
    </div>
    <div style='width: calc(100% - 300px)'>
      <div class='uk-flex uk-padding-small'>
        <el-input type='text' v-model='searchName' style='width:250px' :placeholder="$t('public.enter_guide_name')"
                  clearable></el-input>
        <el-button type='primary' icon='el-icon-search'
                   style='border-right:none !important' @click='onSearch'></el-button>
        <el-button type='primary' @click='onGuideAdd' icon='el-icon-plus'
                   style='border-left:none !important;color: white !important;'></el-button>
      </div>
      <el-table stripe :data='renderGuideList' :header-cell-style='headCellStyle' :cell-style='bodyCellStyle'
                row-key='id'>
        <el-table-column :label="$t('public.guide_item_name')" prop='name'></el-table-column>
        <el-table-column :label="$t('public.guide_code')" prop='code'></el-table-column>
        <el-table-column :label="$t('public.table_create_time')" prop='create_time'>
          <template #default='{row}'>
            <span>{{ $timetransition(row.createTime) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('integration.operation')" prop='operation'>
          <template #default='{row}'>
            <i @click='onGuideItemEdit(row)' class='el-icon el-icon-edit icon-margin cursor-pointer'></i>
            <i @click='onGuideItemSwitchStatus(row)' class='el-icon  icon-margin cursor-pointer'
               :class="row.status? 'el-icon-video-pause':'el-icon-video-play'"></i>
            <i @click='onGuideDelete(row)' class='el-icon el-icon-delete cursor-pointer'></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <EditGroup :show.sync='editGroup.show' @confirm='onGroupConfirm' :group='editGroup.groupData'></EditGroup>
    <EditGuide :show.sync='editGuide.show' @confirm='onGuideConfirm' :guide-item='editGuide.guideData'
               :groups='groupList'></EditGuide>
  </div>
</template>
<script>
import ItemList from '@/components/ItemList/ItemList.vue'
import {
  addGuideGroup,
  addGuideItem,
  delGuideGroup,
  delGuideItem,
  editGuideItem,
  getGroupList,
  getGuideItemList,
  updateGuideGroup,
  updateGuideStatus
} from '@/api/modules/guide'

import EditGroup from '@/pages/system/onlineHelp/components/EditGroup.vue'
import EditGuide from '@/pages/system/onlineHelp/components/EditGuide.vue'
import { detectionTask } from '@/utils/convert'

export default {
  components: {
    EditGuide,
    EditGroup,
    ItemList
  },
  data () {
    return {
      searchName: '',
      groupList: [],
      guideItemList: [],
      editGroup: {
        show: false,
        groupData: {}
      },
      editGuide: {
        show: false,
        guideData: {}
      },
      groupMapper: {
        name: 'group_name',
        id: 'id'
      },
      // 记录当前分组
      currentGroup: {},
      renderGuideList: [],
      detectionTask
    }
  },
  methods: {
    getGroups () {
      getGroupList().then(({ result }) => {
        this.groupList = result
      })
    },
    // 分组被选择
    onGroupSelect (group) {
      this.currentGroup = group
      getGuideItemList(group.id).then(({ result }) => {
        this.guideItemList = result
        this.renderGuideList = [...result]
      })
    },
    // 编辑分组
    onGroupEdit (item) {
      this.editGroup.show = true
      this.editGroup.groupData = item
    },
    onGroupConfirm (guideGroup) {
      if (guideGroup.id) {
        updateGuideGroup(guideGroup).then(({ result }) => {
          this.$message.success($t('public.edit_group')+$t('public.success'))
          this.getGroups()
        })
      } else {
        addGuideGroup(guideGroup).then(({ result }) => {
          this.$message.success($t('public.add_group')+$t('public.success'))
          this.getGroups()
        })
      }
    },
    // 新增分组
    onGroupAdd () {
      this.editGroup.show = true
      this.editGroup.groupData = {}
    },
    // 删除分组
    async onGroupDelete (item) {
      await this.$confirm($t('integration.are_you_sure_you_want_to_delete_group'))
      await delGuideGroup(item.id)
      this.$message.success($t('public.delete_group')+$t('public.success'))
      this.getGroups()
    },
    // 编辑
    onGuideItemEdit (item) {
      this.editGuide.show = true
      this.editGuide.guideData = item
    },
    // guide确认编辑
    onGuideConfirm (guide) {
      if (guide.id) {
        editGuideItem(guide).then(({ result }) => {
          this.$message.success($t('public.edit_guidance_item')+$t('public.success'))
          this.onGroupSelect(this.currentGroup)
        })
      } else {
        addGuideItem(guide).then(({ result }) => {
          if (result) {
            this.$message.success($t('public.add_guidance_item')+$t('public.success'))
            this.onGroupSelect(this.currentGroup)
          } else {
            this.$message.error($t('public.add_guidance_item')+$t('public.fail'))
          }
        })
      }
    },
    async onGuideDelete (guide) {
      await this.$confirm($t('integration.are_you_sure_you_want_to_delete_guide_item'))
      delGuideItem(guide.id).then(({ result }) => {
        this.$message.success($t('public.delete_guidance_item')+$t('public.success'))
        this.onGroupSelect(this.currentGroup)
      })
    },
    onGuideAdd () {
      this.editGuide.show = true
      this.editGuide.guideData = {}
    },
    onSearch () {
      this.renderGuideList = this.guideItemList.filter(item => {
        if (item.name.indexOf(this.searchName) !== -1) {
          return true
        }
        return false
      })
    },
    async onGuideItemSwitchStatus (row) {
      await this.$confirm($t('integration.are_you_sure_you_want_to_modif_status_guide_item'))
      updateGuideStatus(row.id, (!row.status) ? 1 : 0).then(({ result }) => {
        if (result) {
          this.$message.success($t('public.modify_guidance_item_status')+$t('public.success'))
          this.onGroupSelect(this.currentGroup)
        }
      })
    }
  },
  mounted () {
    this.getGroups()
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-icon-plus {
  color: white !important;
}
</style>
